export default __webpack_public_path__ + "static/media/brandon.191c3ed4.jpg";